export function Wordmark({
  tone = "dark",
  size = "md",
}: {
  tone?: "dark" | "light";
  size?: "sm" | "md" | "lg";
}) {
  const title =
    size === "lg" ? "text-3xl md:text-4xl" : size === "sm" ? "text-lg" : "text-xl md:text-[1.4rem]";
  const sub = size === "lg" ? "text-sm" : "text-xs";

  return (
    <span className="inline-flex flex-col leading-none">
      <span
        className={`font-display ${title} tracking-[-0.03em] ${
          tone === "light" ? "text-plum-foreground" : "text-foreground"
        }`}
      >
        Doll Clothes
      </span>
      <span
        className={`font-display italic ${sub} mt-1 font-semibold tracking-[0.16em] ${
          tone === "light" ? "text-gold-soft" : "text-gold-ink"
        }`}
      >
        by Ella Wise
      </span>
    </span>
  );
}
